import React from 'react';
import { CheckIcon, CreditCardIcon, EyeIcon, FlameIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { HERO_IMAGE, offerIncludes } from '../data/content';
import { OFFER_SIZES, OFFER_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/images';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
const trustBadges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function OfferSection() {
  return <section id="oferta" className="w-full scroll-mt-4 bg-cream-200 px-6 py-14 sm:py-16" aria-labelledby="oferta-titulo" data-id="element-116" data-mp="rbtrmcxtfxqd">
      <div className="mx-auto max-w-2xl" data-id="element-117" data-mp="2t59k7fdgrmnz">
        <SectionHeading id="oferta-titulo" title={<>
              Kit Instrumentación Industrial <Accent data-id="element-119" data-mp="2y3kvlujeq58b">Completo</Accent>
            </>} data-id="element-118" data-mp="2t6b3u88jphhb" />

        <div className="relative mx-auto mt-4 w-full max-w-md" data-id="element-120" data-mp="2y679sd0szizi">
          <img src={optimizedImage(HERO_IMAGE, 448)} srcSet={optimizedSrcSet(HERO_IMAGE, OFFER_WIDTHS)} sizes={OFFER_SIZES} alt="Contenido completo del Kit Instrumentación Industrial: 6 volúmenes y 5 bonos" width={1000} height={1000} loading="lazy" decoding="async" className="h-auto w-full" data-id="element-121" data-mp="12p36l7m3dopr" />
          <span className="absolute -right-1 top-2 flex h-24 w-24 flex-col items-center justify-center text-center font-display font-bold leading-none text-white sm:h-28 sm:w-28" style={{
          backgroundColor: '#C86A1A',
          clipPath: 'polygon(50% 0%, 61% 12%, 78% 6%, 82% 24%, 98% 30%, 90% 46%, 100% 60%, 84% 68%, 86% 86%, 68% 84%, 58% 98%, 44% 88%, 28% 96%, 24% 78%, 6% 74%, 12% 58%, 0% 44%, 14% 34%, 8% 16%, 26% 18%, 34% 2%)'
        }} data-id="element-122" data-mp="oxetp240qw7q">
            <span className="text-2xl sm:text-3xl" data-id="element-123" data-mp="16j4mcqy6f46">80%</span>
            <span className="mt-1 text-[0.6rem] uppercase tracking-widest" data-id="element-124" data-mp="17ubwmjlq501">OFF</span>
          </span>
        </div>

        <div className="mt-4 rounded-3xl border border-cream-100/10 bg-forest-800 px-6 py-8 text-center shadow-lift sm:px-10" data-id="element-125" data-mp="3sex3vg79kfbb">
          <p className="text-sm text-cream-100/80" data-id="element-126" data-mp="2ng760yhr8c6">
            Precio normal: <span className="line-through" data-id="element-127" data-mp="2llvzed0uula">$97 USD</span>
          </p>

          <span className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#E9A83B]/35 bg-[#E9A83B]/12 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.14em] text-[#F2C784]" data-id="element-128" data-mp="3ksjhc03beajg">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-129" data-mp="3b2q7p4mqg5hu" />
            Precio de lanzamiento
          </span>

          <p className="mt-5 text-sm text-cream-100/80" data-id="element-130" data-mp="3fvjbnqadn9sv">Precio de lanzamiento:</p>
          <p className="mt-1 font-display text-5xl font-bold text-[#F2C784] sm:text-6xl" data-id="element-131" data-mp="316wwpponwk26">$19 USD</p>
          <p className="mt-2 text-xs" style={{
          color: "#E3A93F"
        }} data-id="element-132" data-mp="364yem7acqdc2">
            Se abona en tu moneda local
          </p>

          

          <CtaButton className="mt-6" variant="gold" fullWidth href={CHECKOUT_URL} label="Sí, Quiero Acceder Ahora" source="oferta" data-id="element-133" data-mp="2s7045cz5j11u" />

          <ul className="mx-auto mt-6 grid max-w-xs grid-cols-2 gap-y-2 text-xs text-cream-100/85" data-id="element-134" data-mp="2dh5fxx06no09">
            {trustBadges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center justify-center gap-1.5" data-id="element-135" data-mp="2middudysemtt">
                <Icon className="h-3.5 w-3.5 text-[#E9A83B]/75" aria-hidden="true" data-id="element-136" data-mp="2mgag17re7pej" />
                {label}
              </li>)}
          </ul>

          <ul className="mt-7 grid gap-1.5 border-t border-cream-100/12 pt-6 text-left" data-id="element-137" data-mp="2wfrhfczm3h4p">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-2 text-xs text-cream-100/80" data-id="element-138" data-mp="2rh6rq7hzkfui">
                <CheckIcon className="h-3 w-3 shrink-0 text-[#E9A83B]/80" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="365b1un2z3j1o" />
                <span className="min-w-0 flex-1 truncate" data-id="element-140" data-mp="3181dzbv8fffy">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-6 max-w-2xl rounded-2xl bg-cream-100/80 p-6 text-center" data-id="element-141" data-mp="3f57wd5c1nc4n">
          <h3 className="font-display text-xl font-semibold text-forest-800" data-id="element-142" data-mp="3aa0tfzqlmbgs">Por qué hoy es el momento</h3>
          <p className="mt-3 text-sm leading-relaxed text-forest-700/90" data-id="element-143" data-mp="18gxqtkuyi6ch">
            Hoy recibís los 6 volúmenes técnicos (360 páginas) + los 5 bonos de implementación (150 páginas) a
            precio de lanzamiento. Después de esta ventana, el precio sube a $97 USD.
          </p>
          <p className="mt-3 text-sm font-semibold text-ember-600" data-id="element-144" data-mp="1m9ndlrib7fan">
            71% de los cupos ya se tomaron. Solo quedan 29 accesos al precio de lanzamiento.
          </p>
        </div>
      </div>
    </section>;
}